import AuthLayout from 'layout/AuthLayout'
import LoginBaseComponent from 'containers/AuthBaseComponent/Login'
import { clientTokenHandler, userToken } from 'utils/oauth'
import { retrieveSecretKey } from 'utils/secret_cache'

export async function getServerSideProps ({ req, res }) {
  const auth = await userToken(req, res)
  const cToken = await clientTokenHandler(req, res)
  let clientSideKeys = null

  if (!cToken) {
    return {
      redirect: {
        permanent: false,
        destination: '/503'
      }
    }
  } else {
    clientSideKeys = {
      NEXT_PUBLIC_SOCIAL_AUTH_GOOGLE_OAUTH2_KEY: retrieveSecretKey('NEXT_PUBLIC_SOCIAL_AUTH_GOOGLE_OAUTH2_KEY'),
      NEXT_PUBLIC_SOCIAL_AUTH_FACEBOOK_KEY: retrieveSecretKey('NEXT_PUBLIC_SOCIAL_AUTH_FACEBOOK_KEY')
    }
  }

  if (auth) {
    res.writeHead(301, {
      Location: '/'
    }).end()
  }

  return {
    props: {
      error: !cToken,
      clientSideKeys
    }
  }
}

export default function Index (props) {
  return (
    <AuthLayout backgroundImage='/images/bg/auth-bg.png'>
      {() => <LoginBaseComponent {...props} />}
    </AuthLayout>
  )
}
